  import { defineComponent, type PropType } from "vue";
  import UserClient98 from '@/extend/controls/user/UserClient98';
  import UserDialog98 from '@/extend/controls/user/UserDialog98';
  import UserIdentifiant from '@/extend/controls/user/UserIdentifiant';
  import UserMail from '@/extend/controls/user/UserMail';
  import UserNom from '@/extend/controls/user/UserNom';
  import UserNumero from '@/extend/controls/user/UserNumero';
  import UserPrenom from '@/extend/controls/user/UserPrenom';
  import UserProfil from '@/extend/controls/user/UserProfil';
  import User from '@/extend/classes/User';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeUser } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      UserClient98,
      UserDialog98,
      UserIdentifiant,
      UserMail,
      UserNom,
      UserNumero,
      UserPrenom,
      UserProfil,
    },

    props: {
      user: {
        type: Object as PropType<User>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        client98Status: new FieldStatus(false, false, 0),
        strClient98: '',
        dialog98Status: new FieldStatus(false, false, 0),
        strDialog98: '',
        identifiantStatus: new FieldStatus(false, false, 0),
        strIdentifiant: '',
        mailStatus: new FieldStatus(false, false, 0),
        strMail: '',
        nomStatus: new FieldStatus(false, false, 0),
        strNom: '',
        numeroStatus: new FieldStatus(false, false, 0),
        strNumero: '',
        prenomStatus: new FieldStatus(false, false, 0),
        strPrenom: '',
        profilStatus: new FieldStatus(false, false, 0),
        strProfil: '',
        refUser: new User,
        cloneUser: new User,
      userSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.USER,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editUser.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editUser: {
        get(): User {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.user != undefined) {
              if (this.user.id == 0) {
                Alerts.debug('CrudUser : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneUser.id != this.user.id && !this.saving) {
                this.handleUserChange();
              }
            }
          }
          return this.refUser;
        },
        set(value: User) {
          this.refUser = value;
        }
      },

      canCreate (): boolean {
        return this.refUser.id > 0;
      },

      canDelete (): boolean {
        return this.refUser.canDelete && this.refUser.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      client98: {
        get(): string {
          return this.strClient98;
        },
        set(value: string) {
          const client98 = parseInt(value);
          if (client98.toString() == value) {
            this.editUser.client98 = client98;
            this.fieldUpdated('CLIENT98', value);
          }
          this.strClient98 = value;
        }
      },


      dialog98: {
        get(): string {
          return this.editUser.dialog98;
        },
        set(value: string) {
          this.editUser.dialog98 = value;
          this.fieldUpdated('DIALOG98', value);
        }
      },


      identifiant: {
        get(): string {
          return this.editUser.identifiant;
        },
        set(value: string) {
          this.editUser.identifiant = value;
          this.fieldUpdated('IDENTIFIANT', value);
        }
      },


      mail: {
        get(): string {
          return this.editUser.mail;
        },
        set(value: string) {
          this.editUser.mail = value;
          this.fieldUpdated('MAIL', value);
        }
      },


      nom: {
        get(): string {
          return this.editUser.nom;
        },
        set(value: string) {
          this.editUser.nom = value;
          this.fieldUpdated('NOM', value);
        }
      },


      numero: {
        get(): string {
          return this.editUser.numero;
        },
        set(value: string) {
          this.editUser.numero = value;
          this.fieldUpdated('NUMERO', value);
        }
      },


      prenom: {
        get(): string {
          return this.editUser.prenom;
        },
        set(value: string) {
          this.editUser.prenom = value;
          this.fieldUpdated('PRENOM', value);
        }
      },


      profil: {
        get(): string {
          return this.strProfil;
        },
        set(value: string) {
          const profil = parseInt(value);
          if (profil.toString() == value) {
            this.editUser.profil = profil;
            this.fieldUpdated('PROFIL', value);
          }
          this.strProfil = value;
        }
      },


      allReadOnly (): boolean {
        const res = this.user.canUpdate && (
        (this.isDisplayed('CLIENT98') && !this.readOnly('CLIENT98')) ||
        (this.isDisplayed('DIALOG98') && !this.readOnly('DIALOG98')) ||
        (this.isDisplayed('IDENTIFIANT') && !this.readOnly('IDENTIFIANT')) ||
        (this.isDisplayed('MAIL') && !this.readOnly('MAIL')) ||
        (this.isDisplayed('NOM') && !this.readOnly('NOM')) ||
        (this.isDisplayed('NUMERO') && !this.readOnly('NUMERO')) ||
        (this.isDisplayed('PRENOM') && !this.readOnly('PRENOM')) ||
        (this.isDisplayed('PROFIL') && !this.readOnly('PROFIL')));
        return !res;
      },

      fields (): string[] {
        return ['CLIENT98', 'DIALOG98', 'IDENTIFIANT', 'MAIL', 'NOM', 'NUMERO', 'PRENOM', 'PROFIL'];
      },
    },

    methods: {
      handleUserChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.user);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.user);
          }
        } else if (!this.inDialog) {
          if (this.cloneUser.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.user);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.client98Status != undefined && this.client98Status.updated) ||
          (this.dialog98Status != undefined && this.dialog98Status.updated) ||
          (this.identifiantStatus != undefined && this.identifiantStatus.updated) ||
          (this.mailStatus != undefined && this.mailStatus.updated) ||
          (this.nomStatus != undefined && this.nomStatus.updated) ||
          (this.numeroStatus != undefined && this.numeroStatus.updated) ||
          (this.prenomStatus != undefined && this.prenomStatus.updated) ||
          (this.profilStatus != undefined && this.profilStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.user);
        }
      },

      setError (): void {
        const error = this.client98Status.error ||
        this.dialog98Status.error ||
        this.identifiantStatus.error ||
        this.mailStatus.error ||
        this.nomStatus.error ||
        this.numeroStatus.error ||
        this.prenomStatus.error ||
        this.profilStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.user);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refUser.id < 0) {
          storeUser.mUserDeleted(this.refUser.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refUser.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveUser()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.userSaving = false;
          this.createRef(this.refUser);
          this.$emit('updated', this.refUser);
          if (this.user.id > 0) {
            this.$emit('saved', this.refUser);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refUser.failed) {
          this.saveLoading = false;
            this.userSaving = false;
            this.refUser.failed = false;
          }
        }
      },

      saveUser (): boolean {
        if (!this.refUser.compareUser(this.cloneUser)) {
          if (!this.userSaving) {
            this.userSaving = true;
          if (this.refUser.id > 0) {
            storeUser.updateUser(this.refUser)
              .then((data: User) => {
                if (!data.failed) {
                  this.refUser = storeUser.getUser(data.id);
                  this.cloneUser = data.cloneUser();
                } else {
                  this.refUser.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.userSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refUser.id <= 0) {
              storeUser.createUser(this.refUser)
                .then((data: User) => {
                  if (!data.failed) {
                    this.refUser = storeUser.getUser(data.id);
                    this.cloneUser = data.cloneUser();
                  } else {
                this.refUser.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.userSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refUser.id <= 0) {
          storeUser.mUserDeleted(this.refUser.id);
        } else {
          storeUser.deleteUser(this.refUser);
        }
      },

      statusClient98 (value: FieldStatus): void {
        this.client98Status = value;
        this.setUpdated();
        this.setError();
      },
      statusDialog98 (value: FieldStatus): void {
        this.dialog98Status = value;
        this.setUpdated();
        this.setError();
      },
      statusIdentifiant (value: FieldStatus): void {
        this.identifiantStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusMail (value: FieldStatus): void {
        this.mailStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNom (value: FieldStatus): void {
        this.nomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumero (value: FieldStatus): void {
        this.numeroStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPrenom (value: FieldStatus): void {
        this.prenomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusProfil (value: FieldStatus): void {
        this.profilStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteUser(): void {
        this.$emit('deleteUser',  this.user);
      },

    addUser(): void {
      this.$emit('addUser',  this.user);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneUser != undefined) {
          this.restoring = true;
          this.refUser.client98 = this.cloneUser.client98;
          this.refUser.dialog98 = this.cloneUser.dialog98;
          this.refUser.identifiant = this.cloneUser.identifiant;
          this.refUser.mail = this.cloneUser.mail;
          this.refUser.nom = this.cloneUser.nom;
          this.refUser.numero = this.cloneUser.numero;
          this.refUser.prenom = this.cloneUser.prenom;
          this.refUser.profil = this.cloneUser.profil;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: User): void {
        this.clearRef();
        this.editUser = value;
        this.cloneUser = value.cloneUser();
        this.client98Status.clear(value.id);
        this.dialog98Status.clear(value.id);
        this.identifiantStatus.clear(value.id);
        this.mailStatus.clear(value.id);
        this.nomStatus.clear(value.id);
        this.numeroStatus.clear(value.id);
        this.prenomStatus.clear(value.id);
        this.profilStatus.clear(value.id);
        this.status.clear();
        this.strClient98 = this.editUser.client98.toString();
        this.strProfil = this.editUser.profil.toString();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CLIENT98') && this.$refs.CLIENT98) this.$refs.CLIENT98.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DIALOG98') && this.$refs.DIALOG98) this.$refs.DIALOG98.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IDENTIFIANT') && this.$refs.IDENTIFIANT) this.$refs.IDENTIFIANT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PROFIL') && this.$refs.PROFIL) this.$refs.PROFIL.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CLIENT98') && this.isDisplayed('CLIENT98') && this.$refs.CLIENT98 && this.$refs.CLIENT98.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DIALOG98') && this.isDisplayed('DIALOG98') && this.$refs.DIALOG98 && this.$refs.DIALOG98.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'IDENTIFIANT') && this.isDisplayed('IDENTIFIANT') && this.$refs.IDENTIFIANT && this.$refs.IDENTIFIANT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MAIL') && this.isDisplayed('MAIL') && this.$refs.MAIL && this.$refs.MAIL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM') && this.isDisplayed('NOM') && this.$refs.NOM && this.$refs.NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO') && this.isDisplayed('NUMERO') && this.$refs.NUMERO && this.$refs.NUMERO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PRENOM') && this.isDisplayed('PRENOM') && this.$refs.PRENOM && this.$refs.PRENOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PROFIL') && this.isDisplayed('PROFIL') && this.$refs.PROFIL && this.$refs.PROFIL.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CLIENT98') && this.$refs.CLIENT98) this.$refs.CLIENT98.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DIALOG98') && this.$refs.DIALOG98) this.$refs.DIALOG98.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IDENTIFIANT') && this.$refs.IDENTIFIANT) this.$refs.IDENTIFIANT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PROFIL') && this.$refs.PROFIL) this.$refs.PROFIL.save();
      },

      getValue (field: string): string {
         if (field == 'CLIENT98') return this.client98.toString();
        else  if (field == 'DIALOG98') return this.dialog98.toString();
        else  if (field == 'IDENTIFIANT') return this.identifiant.toString();
        else  if (field == 'MAIL') return this.mail.toString();
        else  if (field == 'NOM') return this.nom.toString();
        else  if (field == 'NUMERO') return this.numero.toString();
        else  if (field == 'PRENOM') return this.prenom.toString();
        else  if (field == 'PROFIL') return this.profil.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
